import DOMPurify from 'dompurify';
import { ContentCardProps } from '../../components/HelpPages/organisms/ContentCard';
import { OptimizelyContentCardBlock } from '../../types/optimizely/blocks/contentCardBlock';

const localPurifier = DOMPurify();

export const mapToContentCard = (
	optiBlock: OptimizelyContentCardBlock,
): ContentCardProps => {
	return {
		title: optiBlock.title.value || '',
		url: optiBlock.link.value || '',
		...(optiBlock.image && {
			image: {
				src: optiBlock.image?.value?.url || '',
				alt: optiBlock.image?.expandedValue?.alt?.value || '',
			},
		}),
		...(optiBlock.textEditor && {
			summary: localPurifier.sanitize(optiBlock.textEditor.value),
		}),
		anchorId: optiBlock.anchorId,
	};
};
